export default __webpack_public_path__ + "static/section1-4604da018f7237001f1bf3050105862c.gif";